"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Section18_1 = __importDefault(require("./Section18"));
exports.Section18 = Section18_1.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy9pbnRlbGxpdGVjL051cnNpbmdFbnJvbGxtZW50UGFja2V0L3BhcnRzL1NlY3Rpb24xOC9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBLDBEQUFtQztBQUMzQixvQkFERCxtQkFBUyxDQUNDIn0=